const PAGINATION = 'pagination';

export { PAGINATION };
